var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel-directory',_vm._g(_vm._b({attrs:{"title":"Регион","action-type":_vm.actionType,"api-method":_vm.$rApi.directories.getRegions,"input-attrs":_vm.inputAttrs,"no-reset":""}},'panel-directory',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }